export type Person = {
  name?: string | null;
  avatarUrl?: string | null;
  // NULL means "no uploaded avatar". avatarUrl is always populated (it falls
  // back to the deterministic default), so this is the ONLY way to tell that a
  // participant has no real avatar — and it says so without a network request.
  avatarVersion?: string | null;
  profileUrl?: string | null;
  affiliation?: string | null;
};
export type TeamMember = Person & { isCaptain?: boolean | null };
export type Team = { name?: string | null; profileUrl?: string | null; affiliation?: string | null; memberCount?: number | null; members?: TeamMember[] | null };

export function initials(name?: string | null): string {
  if (!name) return '—';
  const parts = String(name).replace(/[0-9]+/g, '').split(/[_\s.\-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return String(name).replace(/[^a-z0-9]/gi, '').slice(0, 2).toUpperCase() || '—';
}

export function shortName(name?: string | null): string {
  if (!name) return '—';
  return String(name).split(/[\s·]+/)[0] || String(name);
}

export function personUrl(p?: Person | null): string | null { return (p && p.profileUrl) || null; }
export function teamUrl(t?: { profileUrl?: string | null } | null): string | null { return (t && t.profileUrl) || null; }
